import Axios from 'axios'
import { Actions } from '../../utils'
import { Config, Header } from '../config.api'

const GetAllDataVesselForecast = async ({ skip, take, filters, status }) => {
  try {
    const response = await Axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/vessel-forecast?skip=${skip}&take=${take}&filter=${filters}&status=${status}`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const InsertVesselForecast = async (payload) => {
  try {
    const response = await Axios.post(
      `${Config.MAIN_SERVICE_ENDPOINT}/vessel-forecast`,
      payload,
      await Header()
    )
    return response
  } catch (error) {
    return error
  }
}

const UpdateVesselForecast = async (payload) => {
  try {
    const response = await Axios.put(
      `${Config.MAIN_SERVICE_ENDPOINT}/vessel-forecast`,
      payload,
      await Header()
    )
    return response
  } catch (error) {
    return error
  }
}

const DeleteVesselForecast = async (payload) => {
  try {
    const response = await Axios.delete(
      `${Config.MAIN_SERVICE_ENDPOINT}/vessel-forecast/${payload}`,
      await Header()
    )
    return response
  } catch (error) {
    return error
  }
}

const GetMasterDataEnum = async (payload) => {
  try {
    const response = await Axios.post(
      `${Config.LINTAS_API}/lintas-sr-master-data/master-enum`,
      payload,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const UploadAttachment = async (formData) => {
  try {
    const headers = await Header()
    const response = await Axios.post(
      `${Config.LINTAS_API}/lintas-sr-attachment/uploader`,
      formData,
      {
        ...headers,
        'Content-Type': 'multipart/form-data'
      },
    )
    return response
  } catch (error) {
    return error
  }
}

const PostGenerateServiceRequest = async (data) => {
  try {
    const requestHeader = await Header()
    const payload = {
      action: Actions.INSERT_SR_PORT,
      data: {
        ...data,
        created_date: new Date().toISOString(),
        modified_date: new Date().toISOString(),
        modified_by: requestHeader.headers.Email,
      }
    }

    const response = await Axios.post(`${Config.MAIN_SERVICE_ENDPOINT}/vessel-forecast-sr`, payload, requestHeader)
    return response
  } catch (error) {
    return error
  }
}

const GetCheckOverlapJetty = async ({ code, jetty_code, all_fast, cast_off }) => {
  try {
    const response = await Axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/vessel-forecast-validate/${code}/${jetty_code}/${all_fast}/${cast_off}`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

export default {
  UploadAttachment,
  GetMasterDataEnum,
  GetCheckOverlapJetty,
  DeleteVesselForecast,
  InsertVesselForecast,
  UpdateVesselForecast,
  GetAllDataVesselForecast,
  PostGenerateServiceRequest,
}